module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av389-7429a9df9258f94d4c417dbc21ad1d62.jpg";